import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams, Link } from 'react-router-dom';
import classNames from 'classnames';
import { CourseContext } from 'context/Context';
import useCourses from 'hooks/useCourses';
//import playIcon from 'assets/img/icons/play.svg';
import ModalVideoContent from './ModalVideoContent';
import Flex from 'components/common/Flex';
//import Hoverbox from 'components/common/Hoverbox';
import SoftBadge from 'components/common/SoftBadge';
import StarRating from 'components/common/StarRating';
import course1 from 'assets/img/e-learning/courses/course1.png';
import beachVideo from 'assets/video/beach.mp4';
import beachPoster from 'assets/video/beach.jpg';
import ProductImage from './ProjectImage';
import { currency } from 'helpers/utils';

const tags = {
 writing: {
  id: 1,
  type: 'primary',
  content: 'Writing',
  icon: 'pen-nib'
 },
 topTrainer: {
  id: 2,
  type: 'success',
  content: 'Top Trainer',
  icon: 'crown'
 },
 editorsChoice: {
  id: 3,
  type: 'warning',
  content: 'Editor’s Choice',
  icon: 'award'
 },
 misc: {
  id: 4,
  type: 'primary',
  content: 'Misc.',
  icon: 'thumbtack'
 },
 design: {
  id: 5,
  type: 'primary',
  content: 'Design',
  icon: 'brush'
 },
 bestSeller: {
  id: 6,
  type: 'success',
  content: 'Best Seller',
  icon: 'hashtag'
 },
 painting: {
  id: 7,
  type: 'primary',
  content: 'Painting',
  icon: 'palette'
 }
};
const course = {
 id: 'CN000001',
 name: 'Script Writing Masterclass: Introdution to Industry Cliches',
 price: 69.99,
 oldPrice: 139.99,
 excerpt:
  'Explore all the advanced design tools like Photoshop, Illustrator, Krita, Procreate, & Inkscape; trace the evolution of graphic design with us, from the first breakthrough of image development to today’s AI assisted designs. Begin your visual language journey with these advanced design tools.',
 trainer: 'Bill Finger',
 thumbnail: {
  image: course1,
  video: beachVideo,
  videoPoster: beachPoster
 },
 totalEnrolled: 92632,
 rating: 4.8,
 review: 78259,
 tags: [tags.writing, tags.topTrainer, tags.editorsChoice]
};
const ProjectList = ({ product /* index */ }) => {
 const { company } = useParams();
 const { _id, name, images, financings, qualities, shortDescription } = product;

 const [showModal, setShowModal] = useState(false);

 const {
  thumbnail: { video, videoPoster },
  tags
 } = course;

 const { isInFavouriteItems /* isInCart */ } = useContext(CourseContext);

 const { /* handleAddToCart */ handleFavouriteClick } = useCourses(course);
 return (
  <>
   <ModalVideoContent show={showModal} setShow={setShowModal} attachment={{ image: videoPoster, src: video }} />
   <Card className="overflow-hidden">
    <Card.Body className="p-0">
     <Row className="g-0">
      <Col md={4} lg={3}>
       <ProductImage name={name} id={_id} images={images} layout="list" />
       {/* <Hoverbox onClick={() => setShowModal(true)} className="h-md-100">
        <Button variant="link" onClick={() => setShowModal(true)} className="p-0 border-0 h-100">
         <Image src={image} alt="" className="w-100 h-100 fit-cover" />
        </Button>
        <Hoverbox.Content className="flex-center pe-none bg-holder overlay overlay-2">
         <Image src={playIcon} width={60} alt="" className="z-index-1" />
        </Hoverbox.Content>
       </Hoverbox> */}
      </Col>
      <Col md={8} lg={9} className="p-x1">
       <Row className="g-0 h-100">
        <Col lg={8} as={Flex} className="flex-column pe-x1">
         <Flex wrap="wrap" className="gap-2 mb-3">
          {tags.map(tag => (
           <SoftBadge key={tag.id} pill bg={tag.type}>
            <FontAwesomeIcon icon={tag.icon} className="me-1" transform="shrink-4" />
            {tag.content}
           </SoftBadge>
          ))}
         </Flex>
         <h5 className="fs-0">
          <Link to={`/project/details/${_id}`}>{name}</Link>
         </h5>
         <h4 className="mt-3 mt-sm-0 fs-0 fs-lg-1">
          <Link to={`/project/details/${_id}`} className="text-900">
           {shortDescription}...
          </Link>
         </h4>
         <p className="fs--1 mt-2 d-none d-lg-block">
          {qualities
           .map(e => e.value)
           .join(', ')
           .substring(0, 142)}
          ...
         </p>
         <div className="flex-1 d-flex align-items-end fw-semi-bold fs--1">
          <span className="me-1 text-900">{4.8}</span>
          <StarRating readonly rating={4.8} />
          <span className="ms-2 text-secondary">{(78259).toLocaleString()} reseñas</span>
         </div>
        </Col>
        <Col lg={4} className="mt-4 mt-lg-0">
         <Flex justifyContent="between" className="h-100 rounded border-lg border-1 flex-lg-column p-lg-3">
          <div className="mb-lg-4 mt-auto mt-lg-0">
           <h4 className="fs-1 text-warning d-flex align-items-center">
            <span>{currency(Math.min(...financings.map(e => e.minInitialPay)), true)}</span>
            <span className="ms-2 fs--1 text-700">Sep</span>
            {/* oldPrice && <del className="ms-2 fs--1 text-700">${oldPrice}</del> */}
           </h4>
           <p className="mb-0 fs--1 text-800">Financia hasta a {Math.max(...financings.map(e => e.maxFinancing))} cuotas</p>
          </div>
          <Flex className="mt-3 flex-lg-column gap-2">
           <Button
            size="sm"
            variant="falcon-default"
            className="fs--1 text-600 white-space-nowrap w-100"
            onClick={handleFavouriteClick}
           >
            <FontAwesomeIcon
             icon={isInFavouriteItems(_id) ? 'heart' : ['far', 'heart']}
             className={classNames({
              'text-danger': isInFavouriteItems(_id)
             })}
            />
            <span className="ms-1 d-none d-lg-inline">{isInFavouriteItems(_id) ? 'Deseado' : 'Añadir a lista'}</span>
           </Button>
           <Button size="sm" variant="primary" className="fs--1" as={Link} to={`/${company}/app/orders/create`}>
            <FontAwesomeIcon icon="shopping-cart" />
            <span className="ms-1 d-none d-lg-inline">Crear orden</span>
           </Button>
          </Flex>
         </Flex>
        </Col>
       </Row>
      </Col>
     </Row>
    </Card.Body>
   </Card>
  </>
 );
};
ProjectList.propTypes = {
 product: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  /* images: PropTypes.arrayOf(
   PropTypes.shape({
    image: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired,
    videoPoster: PropTypes.string.isRequired
   })
  ).isRequired, */
  status: PropTypes.string.isRequired,
  financings: PropTypes.arrayOf(
   PropTypes.shape({
    minInitialPay: PropTypes.number.isRequired,
    maxFinancing: PropTypes.number.isRequired
   })
  ).isRequired,
  qualities: PropTypes.arrayOf(
   PropTypes.shape({
    value: PropTypes.string.isRequired
   })
  ).isRequired,
  shortDescription: PropTypes.string.isRequired,
  stock: PropTypes.number.isRequired
 }).isRequired,
 index: PropTypes.number.isRequired
};

export default ProjectList;
